// $NOTE -- if you add an item to the enum below, ensure you add an entry
// to the lookup table SuiteNameLookup in MetricsContext.ts
export enum MetricsSuites {
  None = 0x0000, // No metrics (disable reporting)

  // Notes similar to C# about usage
  Navigation = 0x0001, // Window.performance.navigation timings
  Bootstrap = 0x0002, // Bootstrap stages/timings
  Commands = 0x0004, // Local+remote execution of commands
  // Unused   = 0x0008, // Currently Unused. Included for completeness
  Rendering = 0x0010, // Rendering of viz panetable
  Debug = 0x0020, // Generic, debugging metrics.
  Toolbar = 0x0040, // Toolbar events
  Fonts = 0x0080, // Font metrics
  HitTest = 0x0100, // Hit-testing/responsive feedback
  Maps = 0x0200, // Maps metrics
  Exporting = 0x0400, // Exporting metrics

  // Combination suites
  Min = Navigation | Bootstrap, // Navigation | Bootstrap
  Core = Min | Commands | 0x0008, // Min | Commands | Unused (assuming Unused is 0x0008)
  All = 0xffff, // All metrics/no filtering
}
